<template>
    <div class="w-100 flex" id="sub-nav-container">
        <div class="sub-nav-menu-item main-nav-items" style="padding: 18px 18px 3px; ">
            <nav id="admin-sub-nav">
                <ul id="admin-sub-nav-bar-list">
                    <li class="admin-sub-nav-item">
                        <admin-nav-menu
                            :admin-items="adminItems"
                            :menu-name="this.data && this.data['menu_name']"
                        />
                    </li>
                    <li class="admin-sub-nav-item">
                        <span class="sub-nav-link">
                        <a href="/portal-order-view/my-orders" id="orders-submitted-by-me-link">
                            <span :class="showingMyOrders">
                                Orders Submitted by Me
                            </span>
                        </a>
                        </span>
                    </li>
                    <li class="admin-sub-nav-item">
                        <span class="sub-nav-link">
                            <a href="/portal-order-view/my-assigned-orders?url=dash" id="my-assigned-orders-link">
                                <span :class="showingMyAssignedOrders">
                                    My Assigned Orders
                                </span>
                            </a>
                        </span>
                    </li>
                </ul>
            </nav>
        </div>
        <div>
            <div class="flex admin-sub-nav-menu-right view-selector-bg">
                <div style="margin: 16px 5px 2px;">
                    {{this.viewLabel}}
                </div>
                <div class="flex sub-nav-view-select-container" style="margin: 18px auto auto;">
                    <label class="view-selector-label">
                        <input
                            class="view-from-radio-label"
                            name="assigned-selector"
                            v-model="selectedViewAsMode"
                            :value="VIEW_FROM"
                            type="radio"
                            data-test="view-from-radio-select"
                        />
                        From
                    </label>
                    <label class="view-selector-label">
                        <input
                            class="view-from-radio-label"
                            name="assigned-selector"
                            :disabled="this.disableAssignTo"
                            v-model="selectedViewAsMode"
                            :value="VIEW_ASSIGNED"
                            type="radio"
                            data-test="assigned-to-radio-select"
                        />
                        Assigned To
                    </label>
                </div>
                <div v-if="selectedViewAsMode === VIEW_FROM" class="flex admin-sub-nav-menu-right-container">
                    <v-select
                        dusk="on-behalf-account-component-nav-bar"
                        data-test="on-behalf-account-select"
                        placeholder="Search Account"
                        append-to-body
                        class="admin-sub-nav-menu-select"
                        :clearable="false"
                        :filterable="false"
                        label="name"
                        :value="proxyAccount"
                        :options="proxyAccountList"
                        @search="onAccountSearch"
                        @input="accountSelected"
                    >
                        <template slot="option" slot-scope="option">
                            <div class="d-center" v-tooltip="option.name">
                                {{ option.name }}
                            </div>
                        </template>
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes"><chevron-down-icon :size="24"/></span>
                        </template>
                        <template slot="no-options">
                            Type name or space to find accounts
                        </template>
                    </v-select>
                    <v-select
                        data-test="on-behalf-user-select"
                        dusk="on-behalf-user-component-nav-bar"
                        placeholder="Select User"
                        name="type"
                        class="admin-sub-nav-menu-select"
                        append-to-body
                        @input="orderFromUserSelected"
                        :value="proxyUser"
                        label="fullname"
                        :options="proxyAccountUsersOptions"
                        :clearable="false"
                    >
                        <template slot="option" slot-scope="option">
                            <div class="d-center" v-tooltip="option.fullname">
                                {{ option.fullname }}
                            </div>
                        </template>
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes"><chevron-down-icon :size="24"/></span>
                        </template>
                        <template slot="no-options">
                                <span v-if="!this.proxyAccount">
                                    Select Account to view users
                                </span>
                            <span v-else>
                                    Type name to find users
                                </span>
                        </template>
                    </v-select>
                </div>
                <div v-if="selectedViewAsMode === VIEW_ASSIGNED" class="flex admin-sub-nav-menu-right-container">
                    <label>
                        <v-select
                            data-test="view-assigned-account-dropdown"
                            placeholder="Acclaro Inc"
                            append-to-body
                            class="admin-sub-nav-menu-select"
                            :clearable="false"
                            label="name"
                            disabled="disabled"
                            :options="[{name: 'Acclaro Inc', id: '9'}]"
                            :reduce="account => account.id"

                        >
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><chevron-down-icon :size="24"/></span>
                            </template>
                            <template slot="no-options">
                                Type name or space to find accounts
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center" v-tooltip="option.name">
                                    {{ option.name }}
                                </div>
                            </template>
                        </v-select>
                    </label>
                    <label>
                        <v-select
                            data-test="view-assigned-user-dropdown"
                            dusk="on-behalf-account-component"
                            placeholder="Select User"
                            append-to-body
                            class="admin-sub-nav-menu-select"
                            :clearable="false"
                            label="fullname"
                            :value="assignedPM"
                            @input="assignedToUserSelected"
                            :options="projectManagers"
                        >
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><chevron-down-icon :size="24"/></span>
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center" v-tooltip="option.fullname">
                                    {{ option.fullname }}
                                </div>
                            </template>
                            <template slot="no-options">
                                Type name or space to find users
                            </template>
                        </v-select>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {ChevronDownIcon} from "../icons";
import {debounce} from "lodash";
import {mapState} from "vuex";
import AdminNavMenu from "./AdminNavMenu";

export default {
    name: "AdminSubNavBar",
    beforeMount() {
        // get
        axios.get('/sub-nav')
            .then(response => {
                this.adminItems["children"] = response.data.admin_options.subnav_items;
                this.data = response.data.sub_nav_data;
                if (this.data.view_mode === "proxy") {
                    let {proxy_user} = this.data;
                    this.selectedViewAsMode = this.VIEW_FROM;
                    this.proxyAccount = {
                        id: this.data.proxy_user.account_id,
                        name: this.data.proxy_user.account_name
                    };
                    if (this.data.proxy_user.id !== null) {
                        this.proxyUser = proxy_user.fullname;
                    } else {
                        this.proxyUser = "Company Admin";
                    }
                } else if (this.data.view_mode === "assignto" || this.data.view_mode === "assign") {
                    this.selectedViewAsMode = this.VIEW_ASSIGNED;
                    this.assignedPM = this.data.assigned_pm.fullname;
                } else if (this.data.view_mode === "me") {
                    this.selectedViewAsMode = this.VIEW_FROM;
                    this.proxyUser = this.data.proxy_user.fullname;
                    this.proxyAccount = {
                        id: this.sessionAccount.id,
                        name: this.sessionAccount.name
                    };
                }
                this.proxyAccountList = this.data.favorite_accounts;
                this.getProxyAccountUsers();
            })
            .catch(e => {
                console.log('Something went wrong!', e);
            });
        axios.get('/orders-view-as-filter/project-managers')
            .then(response => {
                this.projectManagers = response.data.data;
            })
            .catch(e => {
                console.log('Something went wrong!');
            });
    },
    components: {AdminNavMenu, ChevronDownIcon},
    data() {
        return {
            data: undefined,
            subNavItems: [],
            VIEW_FROM: 'view-from',
            VIEW_ASSIGNED: 'view-assigned',
            selectedViewAsMode: 'view-from',
            proxyAccountList: [],
            proxyAccountUsersOptions: [],
            assignedPM: undefined,
            proxyAccount: undefined,
            proxyUser: undefined,
            projectManagers: [],
            adminItems:
                {
                    url: '/admin/accounts',
                    name: 'Admin',
                    children: []
                }
        }
    },
    computed: {
        ...mapState('AuthStore', {
            sessionUser: 'user',
            sessionAccount: 'account',
            role: 'role'
        }),
        isAdminPath() {
            return window.location.pathname.includes('admin') ? "bold" : "";
        },
        isProgramsPath() {
            return window.location.pathname.includes('programs');
        },
        viewLabel(){
            return this.isProgramsPath ? "View Programs:" : "View Orders:"
        },
        disableAssignTo(){
            return this.isProgramsPath;
        },
        showingAssignedTo() {
            if (!this.data) {
                return false;
            }
            return this.data['view_mode'] === 'assignto'
        },
        showingMyOrders() {
            if (!this.data) {
                return '';
            }
            return this.data['view_mode'] === 'me' && !this.isAdminPath ? "bold" : '';
        },
        showingMyAssignedOrders() {
            if (!this.data) {
                return '';
            }
            return this.data['view_mode'] === 'assign' && !this.isAdminPath ? "bold" : '';
        },
    },
    methods: {
        orderFromUserSelected(value) {
            if (value.id == 0) {
                window.location.href = `/portal-order-view/show-company-admin-orders`;
            } else {
                window.location.href = `/portal-order-view/show-orders-from?user_id=${value.id}`;
            }
        },
        onAccountSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchAccounts(loading, search, this);
            }
        },
        accountSelected(value) {
            this.proxyAccount = value;
            this.proxyUser = undefined;
            axios(`/portal-order-view/set-show-account?account_id=${this.proxyAccount.id}`).then(() => this.orderFromUserSelected({id:0}))
        },
        assignedToUserSelected(value) {
            if (value === this.data['resource_user']?.id) {
                window.location.href = '/portal-order-view/my-assigned-orders?url=dash';
            } else {
                window.location.href = `/portal-order-view/show-assigned-to-pm?pm_user_id=${value.id}`;
            }
        },
        getProxyAccountUsers() {
            axios(`/account/${this.proxyAccount.id}/users`)
                .then(result => {
                    this.proxyAccountUsersOptions = result.data.data.map(user => {
                        let {firstname, lastname} = user;
                        return Object.assign({}, user, {fullname: `${firstname} ${lastname}`});
                    });
                    // add company admin option to show all orders
                    this.proxyAccountUsersOptions.unshift({
                        'fullname': "Company Admin",
                        id: 0
                    })
                });
        },
        searchAccounts: debounce((loading, search, vm) => {
            axios.get(`/accounts/all-with-favorites?search=${escape(search)}&only_active=0`).then((res) => {
                vm.proxyAccountList = res.data;
                loading(false);
            });
        }, 350),

    }
}
</script>

<style>

#sub-nav-container {
    background: #ffffff;
    height: 24px;
    color: black;
    flex-direction: row;
    justify-content: space-between;
}

.sub-nav-menu-item {
    padding: 0 10px;
}

header {
    color: black;
    width: 100%;
    background-color: #fff;
}

#admin-sub-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
}

#admin-sub-nav > ul {
    display: flex;
    margin-top: 16px;
    margin-bottom: 0;
    padding: 0;
    align-items: center;
    list-style-type: none;
}


.admin-sub-nav-item {
    margin: 10px;
    font-size: 12px !important;
}

#admin-sub-nav > ul > li > span {
    position: relative;
    display: block;
    height: auto;
    color: #006699;
    text-decoration: none;
    cursor: pointer;
}

#admin-sub-nav > ul > li > span:after {
    display: inline-block;

}

.dropdown li a {
    color: #333333;
    font-size: 12px;
    padding: 5px 5px 5px 8px;
    display: block;
}

.dropdown {
    position: absolute;
    top: 100%;
    left: -3px;
    display: none;
    padding: 0;
    list-style-type: none;
    z-index: 9999;
    width: 220px;
    background-color: #FFFFFF;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
    border: 1px solid #EEEEEE;
    border-bottom: 0;
    border-radius: 5px;
    margin: -2px 0 0;
}

.dropdown li a:hover {
    background-color: rgba(50, 134, 186, .1);
    color: #006699;
}

.isOpen {
    display: grid;
    width: 850px;
    grid-template-columns: repeat(5, 1fr);
}

.admin-sub-nav-menu-right {
    height: 50px;
    margin: auto 0 23px;
    padding-bottom: -10px;
    font-size: 12px;
}

.admin-sub-nav-menu-right-container {
    margin: 8px
}

.bold {
    font-weight: bold;
}

.view-from-radio-label {
    margin: auto 5px;
}

.admin-sub-nav-menu-select {
    width: 235px;
    font-size: 12px;
    padding-right: 5px;
    max-height: 100px;
}

.vs__selected-options {
    flex-wrap: nowrap;
    max-width: calc(100% - 25px); /* change this to `- 40px` if you're supporting a `clearable` field; I was not */
}

.vs__selected {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
}

.vs__dropdown-option {
    font-size: 12px;
    margin: 2px -10px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.vs__no-options {
    font-size: 12px;
}

.vs__dropdown-option--highlight {
    background: #006699;
    color: #fff;
    text-overflow: ellipsis;
    overflow: hidden;
}

.view-selector-label {
    font-weight: 400;
}

.sub-nav-menu-header {
    background: #f5f5f5;
    font-weight: 600;
    color: black;
    padding: 5px;
    border-bottom: 1px solid black
}

</style>
